import { Component, OnInit } from '@angular/core';
import { ViewUploadedDocumentsService } from './view-uploaded-documents.service';
import { DialogService } from '../../shared/services/dialog.service';
import { AppMessages } from '../../shared/constants/messages';
import { DocumentModel } from '../../models/view-uploaded-documents/document.model';
import { AppConstants } from '../../shared/constants/constants';

@Component({
  selector: 'app-view-uploaded-documents',
  templateUrl: './view-uploaded-documents.component.html',
  providers: [ViewUploadedDocumentsService]
})
export class ViewUploadedDocumentsComponent implements OnInit {

  public appConstants = AppConstants;

  title: string;
  documents = new Array<DocumentModel>();
  consultations = [];
  viewModel = {
    consultationId: null,
  };
  message: string;
  constructor(
    public vudService: ViewUploadedDocumentsService,
    public dialogService: DialogService
  ) {

  }

  ngOnInit() {
    this.title = 'View Uploaded Documents';
    this.getAllConsultations();
  }

  getAllConsultations() {
    this.vudService.getAllConsultations().subscribe(res => {
      if (res) {
        const data = res.json();
        this.consultations = data;
        if (this.consultations) {
          if (this.consultations.length > 0) {
            this.viewModel.consultationId = null;
            this.getDocumentByConsultationId(this.viewModel.consultationId);
          } else {
            this.message = AppMessages.viewInvoice.noConsultation;
          }
        }
      }
    });
  }

  getDocumentByConsultationId(consultationId) {
    consultationId = consultationId == null || consultationId === 'null' ? "00000000-0000-0000-0000-000000000000" : consultationId;
    this.vudService.getDocumentsByConsultationId(consultationId).subscribe(res => {
      if (res) {
        this.documents = res.json();
        this.message = !this.documents || this.documents.length < 1 ? AppMessages.viewUploadDocument.noDocument : '';
      }
    });
  }

  changeConsultation(consultationId) {
    this.getDocumentByConsultationId(consultationId);
  }

  clickToDownload(attachmentFile: any) {

    // add Audit Trail
    var model = {
      //userId : localStorage.getItem(this.appConstants.activeLink.userId),
      consultationId: attachmentFile.consultationId,
      message: `download ${attachmentFile.fileName} file`
    };
    this.vudService.addAuditTrail(model).subscribe(res => {
    });

    //window.location.href = document.azurePath;
    // window.open(document.azurePath, "_blank")

    this.vudService.downloadFile(attachmentFile.id)
      .map(res => {
        return {
          filename: attachmentFile.fileName,
          data: res.blob()
        };
      })
      .subscribe(res => {
        //console.log('start download:',res);
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        console.log('download error:', JSON.stringify(error));
      }, () => {
        console.log('Completed file download.')
      });
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-uploaded-documents/view-uploaded-documents.component.ts